import { gql } from '@apollo/client';

export const SEND_INSTANT_ALERT = gql`
  mutation Flex_SendInstantAlert($input: InstantAlertInput!) {
    sendInstantAlert(input: $input) {
      success
      message
    }
  }
`;
